import Vue from 'vue'
import Map from './map-wrapper.vue'

Vue.config.productionTip = false

if(document.getElementById("asp-map")){
    new Vue({
        el: '#asp-map',
        render(createElement) {
            var mapArray = JSON.parse(localStorage.getItem('asp-map-array'));
            return createElement(Map, {
                props: {
                    events: mapArray.events,
                    theme_map: mapArray.theme_map,
                    themes: mapArray.themes,
                    time_periods: mapArray.time_periods,
                    options: mapArray.options
                }
            });
        }
    })
}

